import React from "react";
import { Div, Text } from "atomize";
import WebsiteContainer from "../common/WebsiteContainer";
import CustomContainer from "../common/CustomContainer";
import CardsList from "../common/CardsList";
import CardsListTwo from "../common/CardsListTwo";

const PodcastsList = ({ category, data, text }) => {
  return (
    <>
      <Div>
        <WebsiteContainer>
          <CustomContainer>
            <Text
              textSize={{ xs: "paragraph3", md: "title2" }}
              textWeight="bold"
              m={{ b: "1.25rem" }}
            >
              {text}
            </Text>
            <Div>
              <CardsListTwo category={category} data={data} />
            </Div>
          </CustomContainer>
        </WebsiteContainer>
      </Div>
    </>
  );
};
export default PodcastsList;
